import { object } from 'yup';

import Step from './Step1';

export default {
  title: 'Step 1',
  component: Step,
  validationSchema: () => object().shape({}),
};
